import styled from '@emotion/styled';
import { generateBorder, getBackgroundColor, getPadding, getTextColor, } from './themes';
export const Tag = styled.div `
	cursor: ${(props) => { var _a; return (_a = props.cursor) !== null && _a !== void 0 ? _a : 'default'; }};
	${(props) => props.variant === 'regular'
    ? `display: block;
		     min-height: 26px;
		`
    : `min-height: 20px;`}
	.container {
		display: flex;
		align-items: ${(props) => (props.alignIcon ? props.alignIcon : 'center')};
		gap: 6px;
		padding: ${(props) => getPadding(props.variant)};
		padding: ${(props) => props.contentPadding
    ? props.contentPadding
    : getPadding(props.variant)}px;
		background: ${(props) => getBackgroundColor(props.theme, props.type)};

		border-radius: ${(props) => (props.variant === 'regular' ? '4px' : '12px')};

		${(props) => !props.noBorder &&
    props.theme === 'light' &&
    `border: ${props.version === '2.0' ? 0.5 : 1}px solid ${generateBorder(props.type, props.theme)};`}

		.text {
			color: ${(props) => getTextColor(props.theme, props.type)};
		}

		.icon-trailing {
			all: unset;
			display: flex;
		}

		.icon-leading {
			all: unset;
			display: flex;
		}
	}
`;
//# sourceMappingURL=Tag.styled.js.map